module.exports = __webpack_public_path__ + "img/customize_need.6f1d7c71.svg";